import React, { useContext } from "react";
import { GlobalContext } from "../../../context/global-context-provider";
import styles from "./customers.module.css";
import { Col, Container, Row } from "reactstrap";
import { useTranslation } from "react-i18next";
import customersJson from './customers.json';

const Customers = () => {

    const { t } = useTranslation();
    const { isMobile } = useContext(GlobalContext);

    // Agrupar los clientes en slides para el carousel móvil
    // Cada slide mostrará 12 logos (4 filas × 3 columnas)
    const logosPerSlide = 12;
    const slides = [];
    for (let i = 0; i < customersJson.length; i += logosPerSlide) {
        slides.push(customersJson.slice(i, i + logosPerSlide));
    }

    return(
        <section id="customers" className={`py-5 ${styles.customers}`}>
            <Container className="my-3 mb-0 mb-lg-3">
                <div className={`mx-auto px-3 px-lg-0 mb-4 mb-lg-5 ${styles.titleContainer}`}>
                    <h2 className={`text-center text-primary ${styles.title}`}>
                        <b>
                            <span style={{color: "white"}}>{t("customers-title-1")}</span> {t("customers-title-2")} <span style={{color: "white"}}>{t("customers-title-3")}</span> {t("customers-title-4")}
                        </b>
                    </h2>
                </div>
                <div className="my-3">
                    <img className={styles.LogoMap} src="images/icons/mapa.png" alt="mapa" />
                </div>
                <Container fluid className={styles.imagesContainer}>
                    <div>
                    {customersJson.reduce((rows, icon, idx) => {
                        const count = isMobile ? 6 : 12;
                        const rowIdx = Math.floor(idx / count);
                        if (!rows[rowIdx]) rows[rowIdx] = [];
                        rows[rowIdx].push(icon);
                        return rows;
                    }, []).map((row, i) => (
                        <Row key={i} className="mb-4 justify-content-center">
                            {row.map((icon, j) => (
                                <Col key={icon.name} xs={2} lg={1} className={styles.logoContainer + " d-flex align-items-center px-0 px-lg-2"}>
                                    <img
                                        src={`images/customers/${icon.name}.png`}
                                        alt={icon.name}
                                        style={{ maxWidth: isMobile ? `${icon.mobileWidth}px` : `${icon.width}px`, height: "auto", display: "block", margin: "0 auto" }}
                                    />
                                </Col>
                            ))}
                        </Row>
                    ))}
                    </div>
                </Container>
            </Container>
        </section>
    )
}

export default Customers;